import decode from 'jwt-decode';
import store from '../store';

// all methods that connected with access + refresh pair
export default {
  checkAccessExpire() {
    // get access token form redux store
    const access = store.getters['auth/access'];
    // decode (not verify just decode) jwt access
    // and get expire date from it in timestamp seconds
    let exp;
    try {
      ({ exp } = decode(access));
    } catch (e) {
      // Malformed/absent token: treat as expired so the caller refreshes.
      // Previously jsonwebtoken.decode() returned null here and destructuring
      // it threw a TypeError inside the axios request interceptor.
      return true;
    }
    // boundary timestamp, get current timestamp in seconds minus a minute
    const boundaryTimestamp = (Date.now() / 1000) + 60;
    // (send true) check if token is expired or will be expired in less than a minute
    return exp < boundaryTimestamp;
  },
};
